import moment from 'moment'

export default function timeAgo(date) {
  const pastMoment = moment.utc(date)

  return pastMoment.from(moment.utc()) // e.g. 2 hours ago
}
